module.exports = __webpack_public_path__ + "img/weitu.10e266e4.png";